import { FetchResponseError } from '@/features/fetch'
import type { DistributiveOmit } from '@/features/shared/types'
import type { NavigateToDemande, NavigateToDossier } from '@/router/navigateTo'
import { locationToParams } from '@/features/application/locations'

export type LoadStoreResult = 'Ok' | 'Ko' | 'Access Denied'
type NavigeToDetailDemandeWithId = DistributiveOmit<NavigateToDemande, 'to' | 'context'>
type NavigeToDetailDossierWithCode = DistributiveOmit<NavigateToDossier, 'to' | 'context'>

type NavigateToDetailWithKey = NavigeToDetailDemandeWithId | NavigeToDetailDossierWithCode

export function useDemandeRoutingService() {
  async function loadStoreWithKey(location: NavigateToDetailWithKey): Promise<LoadStoreResult> {// Ne pas déplacer au dessus de la fonction ni dans le catch
    const store = locationToParams({ to: 'detail', ...location } as NavigateToDemande).setup.useStore()
    try {
      const key = 'id' in location ? location.id : location.code
      await store.loadData(key as number)
      return 'Ok'
    } catch (error) {
      if (error instanceof FetchResponseError && error.status === 403) {
        return 'Access Denied'
      }
      console.error(error, location)
      return 'Ko'
    }
  }

  return { loadStoreWithKey }
}
